import { Injectable } from '@angular/core';
import type { Observable } from 'rxjs';
import { of } from 'rxjs';
import {
  LeaderboardTriviaPort,
  type LoadTodayTriviaParams,
  type SubmitTriviaAnswerParams,
} from '../../../domain/leaderboard/ports/leaderboard-trivia.port';
import type {
  LeaderboardTriviaAnswerResult,
  LeaderboardTriviaToday,
} from '../../../domain/leaderboard/models/leaderboard-trivia.model';
import {
  createStubLeaderboardTriviaPending,
  gradeStubTriviaAnswer,
} from '../fixtures/leaderboard-trivia.stub.fixture';

/**
 * In-memory trivia for local demo. Correct answer for the default question is **B**.
 */
@Injectable({ providedIn: 'root' })
export class LeaderboardTriviaStubAdapter extends LeaderboardTriviaPort {
  private readonly answeredKeys = new Set<string>();

  loadToday(params: LoadTodayTriviaParams): Observable<LeaderboardTriviaToday | null> {
    const key = this.sessionKey(params);
    if (!key) {
      return of(null);
    }
    if (this.answeredKeys.has(key)) {
      return of({ kind: 'already_answered', day: 1 });
    }
    return of({ kind: 'pending', trivia: createStubLeaderboardTriviaPending() });
  }

  submitAnswer(params: SubmitTriviaAnswerParams): Observable<LeaderboardTriviaAnswerResult | null> {
    const key = this.sessionKey(params);
    if (!key) {
      return of(null);
    }
    if (this.answeredKeys.has(key)) {
      return of(null);
    }
    const trivia = createStubLeaderboardTriviaPending({ day: params.day });
    const result = gradeStubTriviaAnswer(trivia, params.answer);
    this.answeredKeys.add(key);
    return of(result);
  }

  private sessionKey(params: { commerceId: number; leaderboardId: string; uid: string }): string | null {
    const uid = params.uid?.trim();
    const lb = params.leaderboardId?.trim();
    if (!uid || !lb || !Number.isFinite(params.commerceId)) {
      return null;
    }
    return `${params.commerceId}:${lb}:${uid}`;
  }
}
